import {GET_CANDIDATE_INTERVIEW_DETAILS,GET_CANDIDATE_INTERVIEW_DETAILS_SUCCESS,GET_CANDIDATE_INTERVIEW_DETAILS_FAILURE,POST_CANDIDATE_STAGE,POST_CANDIDATE_STAGE_SUCCESSFULL,POST_CANDIDATE_STAGE_FAILURE, GET_CURRENT_CANDIDATE_STATUS, GET_CURRENT_CANDIDATE_STATUS_SUCCESSFULL, GET_CURRENT_CANDIDATE_STATUS_FAILURE, POST_CANDIDATE_FEEDBACK, POST_CANDIDATE_FEEDBACK_SUCCESSFULL, POST_CANDIDATE_FEEDBACK_FAILURE,GET_CANDIDATE_COMMENT_LIST,GET_CANDIDATE_COMMENT_LIST_SUCCESSFULL,GET_CANDIDATE_COMMENT_LIST_FAILURE,POST_COMMENT_ON_CANDIDATE,POST_COMMENT_ON_CANDIDATE_SUCCESSFULL,POST_COMMENT_ON_CANDIDATE_FAILURE, UPDATE_CANDIDATE_MAPPING_STATUS, UPDATE_CANDIDATE_MAPPING_STATUS_SUCCESS, UPDATE_CANDIDATE_MAPPING_STATUS_FAILED} from "./actionTypes"


const initialState = {
    candidateId:null,
  interviewDetails:null,
  interviewDetailsError:null,
  postCandidateSuccess:null,
  postCandidateFailure:null,
  getCurrentCandidateStatusSuccess:null,
  getCurrentCandidateStatusFailure:null,
  postCandidateFeedbackSuccess:null,
  postCandidateFeedbackFailure:null,
  candidateCommentsList:null,
  candidateCommentsListFailure:null,
  postCommentOnCandidateSuccessfull:null,
  postCommentOnCandidateFailure:null,
  updateCandidateSuccess:null,
  updateCandidateError:null
  }



const candidateInterviewDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
      case GET_CANDIDATE_INTERVIEW_DETAILS:
        state = {
          ...state,
          candidateInterviewDetailsLoader:true,
          candidateId:action.payload,
          interviewDetails:null,
          interviewDetailsError:null,
          postCandidateSuccess:null,
  postCandidateFailure:null,
  getCurrentCandidateStatusSuccess:null,
  getCurrentCandidateStatusFailure:null,
  postCandidateFeedbackSuccess:null,
  postCandidateFeedbackFailure:null,
  candidateCommentsList:null,
  candidateCommentsListFailure:null,
  postCommentOnCandidateSuccessfull:null,
  postCommentOnCandidateFailure:null
          
        }
        break
      case GET_CANDIDATE_INTERVIEW_DETAILS_SUCCESS:
        state = {
          ...state,
          candidateInterviewDetailsLoader:false,
          interviewDetails:action.payload,
          interviewDetailsError:null,
          postCandidateSuccess:null,
  postCandidateFailure:null,
  getCurrentCandidateStatusSuccess:null,
  getCurrentCandidateStatusFailure:null,
  postCandidateFeedbackSuccess:null,
  postCandidateFeedbackFailure:null,
  candidateCommentsList:null,
  candidateCommentsListFailure:null,
  postCommentOnCandidateSuccessfull:null,
  postCommentOnCandidateFailure:null
          
        }
        break
      case GET_CANDIDATE_INTERVIEW_DETAILS_FAILURE:
       
        state = {
          ...state,
          candidateInterviewDetailsLoader:false,
          interviewDetails:null,
          interviewDetailsError:action.payload,
          postCandidateSuccess:null,
  postCandidateFailure:null,
  getCurrentCandidateStatusSuccess:null,
  getCurrentCandidateStatusFailure:null,
  postCandidateFeedbackSuccess:null,
  postCandidateFeedbackFailure:null,
  candidateCommentsList:null,
  candidateCommentsListFailure:null,
  postCommentOnCandidateSuccessfull:null,
  postCommentOnCandidateFailure:null
          
        }
        break

        case POST_CANDIDATE_STAGE:
          state={
            ...state,
            candidateInterviewDetailsLoader:true,
            postCandidateSuccess:null,
            postCandidateFailure:null
          }
          break

        case POST_CANDIDATE_STAGE_SUCCESSFULL:
          state={
            ...state,
            candidateInterviewDetailsLoader:false,
            postCandidateSuccess:action.payload,
            postCandidateFailure:null
          }
          break
          case POST_CANDIDATE_STAGE_FAILURE:
            state={
              ...state,
              candidateInterviewDetailsLoader:false,
              postCandidateSuccess:null,
              postCandidateFailure:action.payload
            }
            break  
            case GET_CURRENT_CANDIDATE_STATUS:
              state={
                ...state,
                candidateInterviewDetailsLoader:true,
                getCurrentCandidateStatusSuccess:null,
                getCurrentCandidateStatusFailure:null,
                postCandidateSuccess:null,
                postCandidateFailure:null,
              }
              break 
              case GET_CURRENT_CANDIDATE_STATUS_SUCCESSFULL:
              state={
                ...state,
                candidateInterviewDetailsLoader:false,
                getCurrentCandidateStatusSuccess:action.payload,
                getCurrentCandidateStatusFailure:null,
                postCandidateSuccess:null,
                postCandidateFailure:null,
              }
              break 
              case GET_CURRENT_CANDIDATE_STATUS_FAILURE:
                state={
                  ...state,
                  candidateInterviewDetailsLoader:false,
                  getCurrentCandidateStatusSuccess:null,
                  getCurrentCandidateStatusFailure:action.payload,
                  postCandidateSuccess:null,
                  postCandidateFailure:null,
                }
                break
                case POST_CANDIDATE_FEEDBACK:
              state={
                ...state,
                candidateInterviewDetailsLoader:true,
                postCandidateFeedbackSuccess:null,
                postCandidateFeedbackFailure:null
              }
              break 
              case POST_CANDIDATE_FEEDBACK_SUCCESSFULL:
                state={
                  ...state,
                  candidateInterviewDetailsLoader:false,
                  postCandidateFeedbackSuccess:action.payload,
                  postCandidateFeedbackFailure:null
                }
                break 
                case POST_CANDIDATE_FEEDBACK_FAILURE:
                  state={
                    ...state,
                    candidateInterviewDetailsLoader:false,
                    postCandidateFeedbackSuccess:null,
                    postCandidateFeedbackFailure:action.payload
                  }
                  break 

                  case GET_CANDIDATE_COMMENT_LIST:
                    state={
                      ...state,
                      candidateInterviewDetailsLoader:true,
                      candidateCommentsList:null,
                      candidateCommentsListFailure:null
                   }
                   break 

                   case GET_CANDIDATE_COMMENT_LIST_SUCCESSFULL:
                    state={
                      ...state,
                      candidateInterviewDetailsLoader:false,
                      candidateCommentsList:action.payload,
                      candidateCommentsListFailure:null
                   }
                   break 
                   case GET_CANDIDATE_COMMENT_LIST_FAILURE:
                    state={
                      ...state,
                      candidateInterviewDetailsLoader:false,
                      candidateCommentsList:null,
                      candidateCommentsListFailure:action.payload
                   }
                   break 

                   case POST_COMMENT_ON_CANDIDATE:
                     state={
                       ...state,
                       candidateInterviewDetailsLoader:true,
                       postCommentOnCandidateSuccessfull:null,
                       postCommentOnCandidateFailure:null

                     }

                     break 

                     case POST_COMMENT_ON_CANDIDATE_SUCCESSFULL:
                     state={
                       ...state,
                       candidateInterviewDetailsLoader:false,
                       postCommentOnCandidateSuccessfull:action.payload,
                       postCommentOnCandidateFailure:null

                     }

                     break 

                     case POST_COMMENT_ON_CANDIDATE_FAILURE:
                      state={
                        ...state,
                        candidateInterviewDetailsLoader:false,
                        postCommentOnCandidateSuccessfull:null,
                        postCommentOnCandidateFailure:action.payload
 
                      }
 
                      break 

                      case UPDATE_CANDIDATE_MAPPING_STATUS:
                      state={
                        ...state,
                        candidateInterviewDetailsLoader:true,
                        updateCandidateSuccess:null,
                        updateCandidateError:null
                       
                      }
 
                      break 
                      case UPDATE_CANDIDATE_MAPPING_STATUS_SUCCESS:
                      state={
                        ...state,
                        candidateInterviewDetailsLoader:false,
                        updateCandidateSuccess:action.payload,
                        updateCandidateError:null
                       
                      }
 
                      break 
                      case UPDATE_CANDIDATE_MAPPING_STATUS_FAILED:
                      state={
                        ...state,
                        candidateInterviewDetailsLoader:false,
                        updateCandidateSuccess:null,
                        updateCandidateError:action.payload
                       
                      }
 
                      break 

        
      default:
        state = { ...state }
        break
    }
    return state
  }
  
  export default candidateInterviewDetailsReducer
  